import { FC } from 'react'

import { PkgReqTypeEnum } from '@/api/package-req/types/PkgReq'
import { ConfirmDialog } from '@/Components/ConfirmDialog'
import FailIcon from '@/Components/icons/fail.svg?react'
interface CancelActionDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  actionType: PkgReqTypeEnum | undefined
  isLoading?: boolean
}

const getActionText = (actionType: string) => {
  switch (actionType) {
    case PkgReqTypeEnum.PhotoRequest:
      return 'צילום'
    case PkgReqTypeEnum.ShrinkRequest:
      return 'צמצום'
    case PkgReqTypeEnum.ReturnRequest:
      return 'החזרה'
    case PkgReqTypeEnum.UniteRequest:
      return 'איחוד'
    default:
      return 'פעולה'
  }
}

export const CancelActionDialog: FC<CancelActionDialogProps> = ({ isOpen, onClose, onConfirm, actionType, isLoading = false }) => {
  const actionText = getActionText(actionType || '')
  return (
    <ConfirmDialog
      isOpen={isOpen}
      Icon={FailIcon}
      onConfirm={onConfirm}
      confirmLoading={isLoading}
      onClose={onClose}
      confirmText='בטל בקשה'
      cancelText='לא עכשיו'
      title={`האם לבטל את בקשת ה${actionText}?`}
      content='אם תרצה, תוכל לשלוח בקשה חדשה מאוחר יותר'
    />
  )
}
